module.exports = __webpack_public_path__ + "img/qiye@2x.e0d18948.png";